module.exports = {
   debounceSearchFilterDelay: 500, //delay in ms
   isDevelopment: process.env.REACT_APP_NODE_ENV === "development",
};
